import { Link } from "react-router-dom";
import { MenuData } from "../data/MenuData";
import '../../styles/menu.css';

export default function Menu({role}) {
    // console.log(MenuData)
    const MenuItem = ({data, index}) => (
        <li key={index} className="menu-parent-li">
            <Link to={data.to} className="item">
                {data.title}
            </Link>
            
            { data.children.length !== 0 && 

                <ul className="menu-child-ul">
                    { data.children.map((cData, cIndex) => (
                        <li key={cIndex} className="itemChild menu-child-li">
                            <Link to={cData.to}>
                                {cData.icon}
                                {cData.title}
                            </Link>
                        </li>
                    ))}
                </ul> 
            }
        </li>
    );
    return (
        <ul className="menu">
            { MenuData && MenuData
                .filter(item => item.access.includes(role))
                .map((item, index) => <MenuItem key={index} data={item} index={index}/>) }
        </ul>
    )
}